import React from 'react';

// Tutorial de las cuentas con sesión (apps/tutorial.js): premios, modo pruebas y reinicio.
// Mismo esquema que AdminArena.

const TIPO = { 0: 'bronce', 1: 'comodín', 3: 'plata', 4: 'oro' };
const NOTA = { fontSize: 13, color: '#ccc', fontFamily: 'Arial, Helvetica, sans-serif' };

const AdminTutorial = () => {
    const [datos, setDatos] = React.useState(null);
    const [form, setForm] = React.useState(null);
    const [cuenta, setCuenta] = React.useState('');
    const [status, setStatus] = React.useState({ text: '', type: '' });
    const [loading, setLoading] = React.useState(false);

    const refresh = React.useCallback(async () => {
        const res = await fetch('/api/tutorialAdmin').then(r => r.json()).catch(() => null);
        if (!res || !res.config) return setStatus({ text: 'No se pudo leer', type: 'error' });
        setDatos(res);
        const c = res.config;
        setForm({ comodin: c.comodin, bronce: c.bronce, combates: c.combates, recompensa: c.recompensa || '', pase: c.pase || '' });
        setCuenta(c.cuentaNombre || '');
    }, []);
    React.useEffect(() => { refresh(); }, [refresh]);

    const enviar = async (body, ok) => {
        setLoading(true);
        setStatus({ text: '', type: '' });
        try {
            const res = await fetch('/api/tutorialAdmin', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
            }).then(r => r.json());
            setStatus(res && res.ok ? { text: ok, type: 'success' } : { text: (res && res.error) || 'No se pudo', type: 'error' });
            await refresh();
        } catch (err) {
            setStatus({ text: 'No se pudo', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    if (!datos || !form) return <div className='heroes formOver'><h1>Tutorial</h1><p>{status.text || 'Cargando...'}</p></div>;

    const c = datos.config;
    const field = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }) });
    const opciones = (filtro) => datos.recompensas.filter(filtro).map(r => (
        <option key={r.id} value={r.id}>{r.name} · {r.price} {TIPO[r.type] || ''}{r.status ? '' : ' (desactivada)'}</option>
    ));

    return (
        <div className='heroes formOver'>
            <h1>Tutorial</h1>
            <p style={NOTA}>
                El recorrido guiado que cada cuenta hace una sola vez al entrar con sesión. Regala 4 Overbox con premio fijo,
                que van aparte de las normales. Aquí solo se cambian las cantidades y las recompensas: el tipo de premio de cada
                Overbox es fijo, porque cada paso depende de él.
            </p>

            <h2>Quién lo ve</h2>
            <p style={NOTA}>
                {c.modo === 'todos'
                    ? 'Activo para todos: le sale a cualquiera que no lo haya hecho.'
                    : c.cuentaNombre ? 'Solo pruebas: únicamente le sale a ' + c.cuentaNombre + '.' : 'Solo pruebas, sin cuenta elegida: no le sale a nadie.'}
            </p>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Cuenta de pruebas (nombre exacto)</label>
                <input className='userSearch' maxLength={60} value={cuenta} onChange={(e) => setCuenta(e.target.value)} />
            </div>
            <div className='navTops heroes unselectable'>
                <div onClick={() => { if (!loading) enviar({ accion: 'modo', modo: 'solo', cuenta }, 'Ahora solo le sale a ' + cuenta + '.'); }}>Solo para esta cuenta</div>
                <div onClick={() => {
                    if (loading || !window.confirm('¿Reiniciar el tutorial de ' + (c.cuentaNombre || 'la cuenta de pruebas') + '? Vuelve al principio y se le dan otra vez los premios.')) return;
                    enviar({ accion: 'reiniciar' }, 'Reiniciado: vuelve a empezar desde el principio.');
                }}>Reiniciar</div>
                {c.modo !== 'todos' ? (
                    <div onClick={() => {
                        if (loading || !window.confirm('¿Activar el tutorial para todos? Le saldrá a cualquiera que no lo haya hecho.')) return;
                        enviar({ accion: 'modo', modo: 'todos' }, 'Activado para todos.');
                    }}>Activar para todos</div>
                ) : null}
            </div>

            <h2>Premios</h2>
            {datos.avisos.map(a => <p key={a} role='alert' style={{ ...NOTA, color: '#ffb4a8' }}>{a}</p>)}
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>1.ª Overbox: birux comodín</label>
                <input className='userSearch' type='number' min='1' {...field('comodin')} onWheel={(e) => e.currentTarget.blur()} />
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>2.ª Overbox: birux de bronce (también el precio máximo de la recompensa que compra)</label>
                <input className='userSearch' type='number' min='1' {...field('bronce')} onWheel={(e) => e.currentTarget.blur()} />
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>3.ª Overbox: recompensa</label>
                <select className='userSearch' {...field('recompensa')}>
                    <option value=''>La que se llame "pato goloso"</option>
                    {opciones(() => true)}
                </select>
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>4.ª Overbox: combates</label>
                <input className='userSearch' type='number' min='1' {...field('combates')} onWheel={(e) => e.currentTarget.blur()} />
            </div>
            <div className='formFieldRow'>
                <label className='formFieldLabel heroes'>Recompensa de comodines que se enseña en la Tienda</label>
                <select className='userSearch' {...field('pase')}>
                    <option value=''>La que se llame "pase plus"</option>
                    {opciones(r => r.type === 1)}
                </select>
            </div>
            <div className='navTops heroes unselectable'>
                <div onClick={() => { if (!loading) enviar({ accion: 'premios', ...form }, 'Premios guardados.'); }}>Guardar premios</div>
            </div>

            {loading ? <p>Cargando...</p> : null}
            {status.text ? (
                <p
                    role={status.type === 'error' ? 'alert' : 'status'}
                    style={{
                        padding: '8px 12px',
                        borderRadius: 4,
                        fontWeight: 600,
                        color: status.type === 'success' ? '#0a6b0a' : '#8a1a1a',
                        backgroundColor: status.type === 'success' ? '#d9f5d9' : '#fdecea'
                    }}
                >
                    {status.text}
                </p>
            ) : null}
        </div>
    );
};

export default AdminTutorial;
